const stats = [
  { icon: 'ri-article-line', number: '15,800+', label: '爆料文章' },
  { icon: 'ri-user-smile-line', number: '8,600万', label: '月活跃用户' },
  { icon: 'ri-flashlight-line', number: '24小时', label: '全天候追踪' },
  { icon: 'ri-chat-check-line', number: '230万+', label: '用户评论' },
];

export default function StatsSection() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold tracking-widest uppercase text-secondary-500">PLATFORM DATA</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-1">
            平台数据
          </h2>
          <p className="text-sm text-foreground-600 mt-2">
            吃瓜爆料网已成为中文互联网领先的娱乐资讯聚合平台
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 max-w-4xl mx-auto">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-background-50 rounded-2xl p-6 md:p-8 text-center border border-background-200/70"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className={`${stat.icon} text-xl text-primary-500`} />
              </div>
              <p className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 mb-1">
                {stat.number}
              </p>
              <p className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}